module.exports = __webpack_public_path__ + "img/pic4@2x.72a80eee.png";